'use client';

import Icon from '@/components/ui/AppIcon';

interface LeadFiltersProps {
  currentFilter: 'all' | 'new' | 'contacted' | 'quoted' | 'booked' | 'cancelled';
  onFilterChange: (filter: 'all' | 'new' | 'contacted' | 'quoted' | 'booked' | 'cancelled') => void;
}

const LeadFilters = ({ currentFilter, onFilterChange }: LeadFiltersProps) => {
  const filters = [
    { value: 'all', label: 'All Leads', icon: 'QueueListIcon' },
    { value: 'new', label: 'New', icon: 'BellAlertIcon' },
    { value: 'contacted', label: 'Contacted', icon: 'ChatBubbleLeftRightIcon' },
    { value: 'quoted', label: 'Quoted', icon: 'DocumentTextIcon' },
    { value: 'booked', label: 'Booked', icon: 'CheckCircleIcon' },
    { value: 'cancelled', label: 'Cancelled', icon: 'XCircleIcon' },
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {filters.map((filter) => (
        <button
          key={filter.value}
          onClick={() => onFilterChange(filter.value as any)}
          className={`px-4 py-2 rounded-lg font-bold text-sm transition-all duration-300 flex items-center gap-2 ${
            currentFilter === filter.value
              ? 'bg-gradient-to-r from-primary to-secondary text-white shadow-lg'
              : 'bg-surface text-foreground hover:bg-accent/10'
          }`}
        >
          <Icon name={filter.icon as any} size={16} />
          <span>{filter.label}</span>
        </button>
      ))}
    </div>
  );
};

export default LeadFilters;